import moment from 'moment';
import { mapGetters } from 'vuex';
import PriceCardLocalisations from '../../lang/PriceCard';
import Accounting from '../../mixins/accounting';
import branding from '../../mixins/branding';

require('./scss/product-details-simplified.scss');

export default {
    props: ['product', 'currencyIsChanging', 'showTermsAndConditions', 'upsellCardType', 'vehicle'],

    mixins: [Accounting, branding],

    i18n: PriceCardLocalisations,

    data() {
        return {
            hasNoProducts: false,
        };
    },

    template: `
        <ul
            :class="[
                'product-details',
                {
                    'mb-0 modal-product-details pl-3 product-details': upsellCardType === 'mobile-us-product-upsell',
                    'p-0 modal-product-details': upsellCardType === 'us-product-upsell',
                    'mb-4 mt-4': upsellCardType === 'row-product-upsell'
                },
            ]"
            v-if="product">
        <li v-if="
            !usBooking ||
            (
                usBooking && upsellCardType === 'us-product-upsell' &&
                insuranceExcessFromVehicleWithoutConversion(productOrVehicle, quote.selected_vehicle, vehicle) > 0
            )
        ">
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img v-if="upsellCardType === 'row-product-upsell'" svg-inline :src="icon('checkbox-border-ticked-alt')">
                    <img v-else svg-inline :src="icon('checkbox-border-ticked-alt')">
                </span>
            </span>
            <span>
                {{ $t('PriceCard.excess_liability') }}
                <strong v-if="currencyIsChanging">&hellip;</strong>
                <span v-else>
                    <strong>
                        {{ insuranceExcessPrice(productOrVehicle, quote.selected_vehicle, vehicle)}}
                    </strong>
                    <span class="old-price" v-if="basicProduct && notBasicProductSelected && !usBooking">
                        ({{ insuranceExcessPrice(basicProduct, quote.selected_vehicle, vehicle) }})
                    </span>

                </span>
            </span>
        </li>
        <li>
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img v-if="upsellCardType === 'row-product-upsell'" svg-inline :src="icon('checkbox-border-ticked-alt')">
                    <img v-else svg-inline :src="icon('checkbox-border-ticked-alt')">
                </span>
            </span>
            <span>
                {{ $t('PriceCard.security_deposit') }}
                <strong v-if="currencyIsChanging">&hellip;</strong>
                <span v-else>
                    <strong>
                        {{ insuranceDepositPrice(product, quote.selected_vehicle, vehicle)}}
                    </strong>
                    <span class="old-price" v-if="basicProduct && notBasicProductSelected && !usBooking">
                        ({{ insuranceDepositPrice(basicProduct, quote.selected_vehicle, vehicle) }})
                    </span>
                </span>
            </span>
        </li>
        <li>
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img v-if="upsellCardType === 'row-product-upsell'" svg-inline :src="icon('checkbox-border-ticked-alt')">
                    <img v-else svg-inline :src="icon('checkbox-border-ticked-alt')">
                </span>
            </span>
            <span>
                {{ $t('PriceCard.fuel_policy') }}
                <template v-if="productOrVehicle.fuel_policy == 'SL'">{{ $t('PriceCard.like_for_like') }}</template>
                <template v-if="productOrVehicle.fuel_policy == 'FF'">{{ $t('PriceCard.full_to_full') }}</template>
            </span>
        </li>
        <li>
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img v-if="upsellCardType === 'row-product-upsell'" svg-inline :src="icon('checkbox-border-ticked-alt')">
                    <img v-else svg-inline :src="icon('checkbox-border-ticked-alt')">
                </span>
            </span>
            <span>
            <template v-if="mileageUnit == 'Miles'">
                <template v-if="productOrVehicle.mileage">
                    {{ $t('PriceCard.miles_per_rental', { mileage: productOrVehicle.mileage }) }}
                </template>
                <template v-else-if="vehicle && vehicle.mileage">
                    {{ $t('PriceCard.miles_per_rental', { mileage: vehicle.mileage }) }}
                </template>
                <template v-else-if="selectedVehicle && selectedVehicle.mileage">
                    {{ $t('PriceCard.miles_per_rental', { mileage: selectedVehicle.mileage }) }}
                </template>
                <template v-else>
                    {{ $t('PriceCard.unlimited_mileage') }}
                </template>
            </template>
            <template v-else>
                <template v-if="productOrVehicle.mileage">
                    {{ $t('PriceCard.km_per_rental', { mileage: productOrVehicle.mileage }) }}
                </template>
                <template v-else-if="vehicle && vehicle.mileage">
                    {{ $t('PriceCard.km_per_rental', { mileage: vehicle.mileage }) }}
                </template>
                <template v-else-if="selectedVehicle && selectedVehicle.mileage">
                    {{ $t('PriceCard.km_per_rental', { mileage: selectedVehicle.mileage }) }}
                </template>
                <template v-else>
                    {{ $t('PriceCard.unlimited_mileage_km') }}
                </template>
            </template>
            </span>
        </li>
        <li>

            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img svg-inline :src="icon('checkbox-border-ticked-x')" v-if="product.type=='BAS' || hasNoProducts">
                    <img svg-inline :src="icon('checkbox-border-ticked-alt')" v-else>
                </span>
            </span>
            <span>
                <template v-if="product.type=='BAS' || hasNoProducts"> {{ $t('PriceCard.non_refundable') }}</template>
                <template v-else-if="product.type=='PMP' && cancellationUntil.isAfter()">
                    {{ $t('PriceCard.free_cancellation_until') }} {{ cancellationUntil.format('DD MMM') }}
                </template>
                <template v-else-if="!hasNoProducts">
                    {{ $t('PriceCard.cancellation_in_line_with') }}&nbsp;<a @click.stop.prevent="showTermsAndConditions" href="#"><span v-html="$t('PriceCard.tcs')"></span></a>
                </template>
            </span>
        </li>
        <li v-if="product.type == 'BAS' || hasNoProducts">
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img svg-inline :src="icon('checkbox-border-ticked-x')">
                </span>
            </span>
            <span>
                <template>{{ $t('PriceCard.non_amendable') }}</template>
            </span>
        </li>
        <li v-if="product.type == 'PMP'">
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img v-if="upsellCardType === 'row-product-upsell'" svg-inline :src="icon('checkbox-border-ticked-alt')">
                    <img v-else svg-inline :src="icon('checkbox-border-ticked-alt')">
                </span>
            </span>
            <span>{{ $t('PriceCard.glass_and_tyres_covered') }}
            </span>
        </li>
        <li v-if="product.debit_card == 'Y'">
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img v-if="upsellCardType === 'row-product-upsell'" svg-inline :src="icon('checkbox-border-ticked-alt')">
                    <img v-else svg-inline :src="icon('checkbox-border-ticked-alt')">
                </span>
            </span>
            <span>{{ $t('PriceCard.debit_card_deposit') }}
            </span>
        </li>
        <li v-if="product.type == 'PMP'">
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img svg-inline :src="icon('extras')">
                </span>
            </span>
            <span>{{ $t('PriceCard.free_extras_on_collection') }}
            </span>
        </li>
        <li v-if="product.fast_track == 'Y'">
            <span class="w-8 text-center icon">
                <span class="inline w-6">
                    <img v-if="upsellCardType === 'row-product-upsell'" svg-inline :src="icon('checkbox-border-ticked-alt')">
                    <img v-else svg-inline :src="icon('checkbox-border-ticked-alt')">
                </span>
            </span>
            <span>{{ $t('PriceCard.fast_track_included') }}
            </span>
        </li>
        </ul>`,

    watch: {
        'vehicle.products.data': {
            handler(newVal) {
                this.hasNoProducts = Array.isArray(newVal) && newVal.length === 0;
            },
            immediate: true,
            deep: true,
        },
    },

    computed: {
        usBooking() {
            if (this.upsellCardType && this.upsellCardType === 'us-product-upsell') {
                return true;
            }

            return false;
        },
        usLocation() {
            return (this.userLocation && this.userLocation?.countryCode === 'US') && this.quote?.us_location;
        },
        usSourceCheck() {
            if (this.quote?.us_location && !this.vehicle?.products || this.usLocation) {
                return 'us-product-upsell';
            }
            return 'row-product-upsell';
        },
        cancellationUntil() {
            return moment(this.quote.utc_pickup_datetime).subtract(2, 'days');
        },
        mileageUnit() {
            try {
                return this.quote.pickup_location.data.country.data.mileage_type
            } catch (e) {
                return 'Kilometers';
            }
        },
        basicProduct() {
            try {
                return this.quote
                    .selected_vehicle.data
                    .vehicle.data
                    .products.data.find((product) => product.type == 'BAS');
            } catch (e) {
                return null;
            }
        },
        notBasicProductSelected() {
            try {
                return this.product && this.product.type !== 'BAS';
            } catch (e) {
                return false;
            }
        },
        productOrVehicle() {
            if (Object.keys(this.product).length === 0 && this.vehicle !== null) {
                return this.vehicle;
            }

            return this.product;
        },
        selectedVehicle() {
            return this.quote?.selected_vehicle?.data?.vehicle?.data;
        },
        ...mapGetters({
            quote: 'getQuote',
            selectedCurrency: 'selectedCurrency',
            selectedVehicle: 'selectedVehicle',
            userLocation: 'getUserLocation',
        })
    },

    methods: {
        icon(name) {
            return this.brandingImagesPath(`/images/svgs/${name}.svg`);
        }
    },
}